import React from 'react';

import WatchListBtn from '../../../watchlist-btn/WatchListBtn';

export type WatchListTeaserProps = {
  id: string;
  overline?: string;
  href: string;
  image: {
    src: string;
    srcSet: string;
    alt?: string;
  };
  title: string;
  intro?: string;
  tags?: {
    title: string;
  }[];
  cta: string;
  labels: {
    add: string;
    remove: string;
  };
  hideTeaserButton: boolean;
};

const WatchListTeaser = ({
  id,
  overline,
  intro,
  title,
  image,
  tags,
  href,
  cta,
  labels,
  hideTeaserButton
}: WatchListTeaserProps) => (
  <div className="watch-list__teaser">
    <a href={href} className="watch-list__teaser-link has-hoverable-children">
      <div className="watch-list__teaser-image">
        <img
          alt={image.alt}
          src={image.src}
          srcSet={image.srcSet}
          sizes=""
        ></img>
      </div>
      <div className="watch-list__teaser-content">
        {overline && (
          <p className="watch-list__teaser-subline typo-label font-uppercase">
            {overline}
          </p>
        )}
        <p className="typo-headline-4">{title}</p>
        {intro && <p className="typo-copy">{intro}</p>}
        {tags && (
          <div className="watch-list__teaser-topics">
            {tags.map((item) => (
              <span key={item.title} className="tag">
                {item.title}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className="watch-list__teaser-meta">
        <div className="button watch-list__teaser-cta">
          <span className="button__icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.49581 3L12.575 8.07914L7.49581 13.1583L6.67086 12.3333L10.3417 8.66247L3 8.66248V7.49581L10.3417 7.49581L6.67086 3.82496L7.49581 3Z" />
            </svg>
          </span>
          <span className="button__label">{cta}</span>
        </div>
      </div>
    </a>
    {!hideTeaserButton && (
      <WatchListBtn id={id} title={title} labels={labels} />
    )}
  </div>
);

export default WatchListTeaser;
